module.exports = __webpack_public_path__ + "static/media/soundIcon.2ea89abe.svg";